import React from 'react';
import { Redirect  } from 'react-router-dom';

const PrivateRouteB2B = ({ children }) => {
  if (typeof window === 'undefined') {
    // Si exécuté côté serveur, retourne null ou un fallback
    return null;
  }

  const token = localStorage.getItem('token_b2b');

  if (!token) {
    return <Redirect  to="/b2b-login" replace />;
  }

  return children;
};

export default PrivateRouteB2B;
